// Unpublished Work © 2021-2025 Deere & Company.

import t from 'tcomb';
import {ButtonFeature} from './button-feature';
import {PreFilledFacets} from './pre-filled-facets';
import {CustomerType} from '../../../enum/customer-type';

export const AddNewCustomerButtonFeature = ButtonFeature.extend({
    supportContext: t.Boolean,
    retailFinancingType: t.maybe(t.String)
}, {
    defaultProps: {
        supportContext: false
    },
    name: 'AddNewCustomerButtonFeature'
});

export const AddToContextButtonFeature = ButtonFeature.extend({
    disableWithoutIndividualAndFinancialMembership: t.Boolean,
    tooltipLabel: t.maybe(t.String),
    allowedCustomerTypeForSelect: t.list(CustomerType)
}, {
    defaultProps: {
        disableWithoutIndividualAndFinancialMembership: false,
        show: false,
        allowedCustomerTypeForSelect: []
    },
    name: 'AddToContextButtonFeature'
});

export const Search = t.struct({
    addNewCustomerButton: AddNewCustomerButtonFeature,
    addToContextButton: AddToContextButtonFeature,
    disableCustomerMerge: t.Boolean,
    disableProfileNavigation: t.Boolean,
    filterCountryList: t.Array,
    preFilledFacets: PreFilledFacets,
    showDeceasedOutOfBusiness: t.Boolean,
    showCancelButton: t.Boolean
}, {
    defaultProps: {
        addNewCustomerButton: AddNewCustomerButtonFeature({}),
        addToContextButton: AddToContextButtonFeature({}),
        disableCustomerMerge: false,
        disableProfileNavigation: false,
        filterCountryList: [],
        preFilledFacets: PreFilledFacets({}),
        showCancelButton: false,
        showDeceasedOutOfBusiness: false
    },
    name: 'SearchFeature',
    strict: true
});
